import { createSlice } from "@reduxjs/toolkit";

const initalCountriesDataState = {data: {},status: ''}

const countriesDataSlice = createSlice({
    name: 'countries',
    initialState: initalCountriesDataState,
    reducers: {
        countries(state, action){
            state.data      = action.payload.data
            state.status    = action.payload.status
        },
    },
});

export const countriesDataActions = countriesDataSlice.actions;
export default countriesDataSlice.reducer;
